import React from 'react';
import { useGetRentalReturnPhotosQuery } from '../../../api/booking/rentalReturnPhotosApiSlice';
import ReturnPhotoThumbnail from './ReturnPhotoThumbnail';

interface RentalReturnPhotoThumbnailProps {
    orderId: string;
    // When true, render an informational placeholder instead of nothing once
    // the query has resolved with no photo (e.g. the customer tapped "skip"
    // on return). Gated by the caller to the use cases where return-photo
    // capture is actually live, so finished bookings of other services don't
    // surface a misleading "no photo" note.
    showEmptyState?: boolean;
    /** #3219: the booking location's zone; the station default when omitted. */
    timeZone?: string;
}

// SUP / rental return photo, stored on the `rental` table. Thin fetching wrapper
// over the shared presentational `ReturnPhotoThumbnail`.
const RentalReturnPhotoThumbnail: React.FC<RentalReturnPhotoThumbnailProps> = ({
    orderId,
    showEmptyState = false,
    timeZone,
}) => {
    const { data, isLoading, isError } = useGetRentalReturnPhotosQuery(
        { orderId },
        { skip: !orderId },
    );

    return (
        <ReturnPhotoThumbnail
            photos={data?.photos ?? []}
            status={data?.status}
            isLoading={isLoading}
            isError={isError}
            showEmptyState={showEmptyState}
            timeZone={timeZone}
        />
    );
};

export default RentalReturnPhotoThumbnail;
